<template>
    <div class="m-dialog" :class="'m-dialog--'+type" v-show="content">
        <p class="m-dialog--content relative" v-html="content"></p>
    </div>
</template>

<script>
export default {
  name: 'Dialog',
  props: {
    type: String, // 顏色 green white
    nickname: String,
    content: String
  }
}
</script>

<style scoped lang="scss">
.m-dialog{
    position: relative;
    top: 57%;
    left: 70px;
    max-width: 300px;
    display: inline-block;
    letter-spacing: 1.2px;
    transition: 0.4s map-get($ease, 'IOquad');
    border-radius: 50px;
    box-shadow: 0 3px 6px rgba($color-primary ,0.2);
    color: $color-primary;
    padding: 10px 20px;
    &:after{
        content: '';
        position: absolute;
        bottom: -17px;
        left: -5px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 50px 20px 0 20px;
        transform: rotate(45deg);
        z-index: 0;
    }
    &--content{
        transition: 0.4s map-get($ease, 'IOquad');
        font-size: clamp(15px, 2.5vw, 17px);
        z-index: 1;
    }
    &--green {
        background: $color-secondaryL;
        border: 1px solid $color-secondaryL;
        &:after{
            border-color: $color-secondaryL transparent transparent transparent;
        }
    }
    &--white {
        background: $white;
        border: 1px solid $white;
        &:after{
            border-color: $white transparent transparent transparent;
        }
    }
    @include respond-to(sm) {
        top: 45%;
        left: 160px;
    }
     @include respond-to(md) {
         max-width: none;
         top: 50%;
     }
    @include respond-to('1200') {
        left: 180px;
    }
    @include respond-to(xl) {
        padding: 25px 40px;
        top: 27%;
        left: 250px;
    }
}

</style>
